import { Button, Grid, Typography } from '@mui/material';
import { deDE } from '@mui/x-data-grid';
import React, { useMemo } from 'react';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { CrudDataGrid } from '../public/Dialog/generic/CrudDataGrid';
import { present } from '../public/Dialog/generic/utilities';

interface IProps {
  title: string;
  text?: string;
  idRelationshipRole?: number;
  legalClientArray: ILegalClient[];
  filter?: (legalClient: ILegalClient) => boolean;
  onClickNew?: () => void;
  onRowClick?: (legalClient: ILegalClient) => void;
  onRemoveClick?: (legalClient: ILegalClient) => void;
}

export const TableLegalClient: React.FC<IProps> = ({
  title,
  text,
  idRelationshipRole,
  legalClientArray,
  onRemoveClick,
  onClickNew,
  onRowClick,
  filter = () => true,
}) => {
  const handleRemove = (legalClient: ILegalClient) => {
    onRemoveClick?.(legalClient);
  };

  const filteredLegalClients = useMemo(() => {
    return legalClientArray.filter(
      x =>
        (idRelationshipRole === undefined ||
          x.idRelationshipRole === idRelationshipRole) &&
        filter(x)
    );
  }, [legalClientArray, idRelationshipRole, filter]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={present(onClickNew) ? 6 : 12}>
        <Typography variant='h4'>{title}</Typography>
      </Grid>
      {present(onClickNew) && (
        <Grid item xs={6}>
          <Button
            sx={{ float: 'right' }}
            variant='contained'
            onClick={onClickNew}
          >
            Hinzufügen
          </Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography>{text}</Typography>
      </Grid>
      <Grid item xs={12}>
        <CrudDataGrid<ILegalClient>
          rows={filteredLegalClients}
          columns={[
            {
              field: 'fullName',
              headerName: 'Name',
              flex: 1,
              valueGetter: params =>
                `${params.row.FirstName || ''} ${params.row.LastName || ''}`,
            },
          ]}
          getRowId={row => row.idLegalClient}
          onClickEdit={
            onRowClick &&
            (id => {
              onRowClick(legalClientArray.find(lc => lc.idLegalClient === id)!);
            })
          }
          onClickDelete={
            onRemoveClick &&
            (id =>
              handleRemove(
                legalClientArray.find(lc => lc.idLegalClient === id)!
              ))
          }
          autoHeight
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          disableRowSelectionOnClick
        />
      </Grid>
    </Grid>
  );
};
